"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
function Iframe(props) {
    const iframeRef = react_1.useRef(null);
    const iframeCallbackRef = react_1.useCallback((node) => {
        iframeRef.current = node;
    }, []);
    react_1.useEffect(() => {
        const onBlur = () => {
            if (document.activeElement &&
                document.activeElement.nodeName.toLowerCase() === 'iframe' &&
                iframeRef.current &&
                iframeRef.current === document.activeElement) {
                // infer a click event
                props.onInferredClick(iframeRef.current);
            }
        };
        window.addEventListener('blur', onBlur);
        return () => {
            window.removeEventListener('blur', onBlur);
        };
    }, []);
    return react_1.default.createElement("iframe", Object.assign({}, props, { ref: iframeCallbackRef }));
}
exports.default = Iframe;
//# sourceMappingURL=index.js.map